export default __webpack_public_path__ + "c261a0d6e7bc2ca3ef9bfdf6444cd55c.svg";